@for (day of this.getClassNumbers(); track day) {
  <mat-list>
    <div mat-subheader class="subhead">Day {{day}}</div>
    @for (item of this.filterTiming(day); track item) {
      <mat-list-item>
        <mat-icon matListItemIcon class="icon">schedule</mat-icon>
        <div matListItemTitle class="title">{{this.getDay(item)}}</div>
        <div matListItemLine class="line">{{this.getTime(item)}}</div>
      </mat-list-item>
    }
  </mat-list>
}
<mat-divider></mat-divider>